<div *ngIf="isloader" class="h-100 w-100 padt-5">
    <mat-progress-bar [mode]="'indeterminate'">
    </mat-progress-bar>
</div>
<div class="h-100 w-100">
    <app-dover-common-table [tableData]="transformedVitalData"
        [columnHeader]="vitalsHistoryConfig?.vitalsHistoryTableHeader?vitalsHistoryConfig?.vitalsHistoryTableHeader:{}"
        [pageType]="'vitals'" [pager]="pager" (doverTableAction)="doverTableAction($event)">
    </app-dover-common-table>
</div>